export enum SurveySource {
  SATELLITE = 'satellite'
}
